import React from "react";

import {
  Document,
  Page,
  View,
  Text,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { colors } from "../../imports/constants";
import i18n from "../../imports/i18n";
import FbLogo from "../../assets/fb_logo.png";

export default function NotarizeDocument(props) {
  const { notarization } = props;
  const documentTable = [
    { key: "cellData", subKey: ["name"] },
    { key: "zipHash", subKey: [false] },
    { key: "ipfsAddresses", subKey: ["zip"] },
  ];

  const transactionFields = [
    {
      key: "tx",
      subKey: ["from", "to", "transactionHash", "blockNumber"],
    },
  ];

  const generateTable = fields =>
    fields.map(({ key, subKey }) =>
      subKey?.map(field => (
        <View key={field} style={styles.row}>
          <View
            style={{
              ...styles.leftCell,
              ...styles.centered,
            }}
          >
            <Text style={styles.leftText}>
              {i18n.t(`pdfGenerator.${field ? field : "zipHash"}`)}
            </Text>
          </View>
          <View
            style={{
              ...styles.rightCell,
              ...styles.centered,
              alignItems: "flex-start",
              paddingLeft: 10,
            }}
          >
            <Text style={styles.rightText}>
              {/* {subKey ? notarization?.[key]?.[subKey] : notarization?.[key]} */}
              {field ? notarization?.[key]?.[field] : notarization?.[key]}
            </Text>
          </View>
        </View>
      )),
    );

  return (
    <Document style={{ width: "100%", height: "100%" }}>
      <Page size="A4" style={styles.page}>
        <View style={styles.innerPage}>
          <View
            style={{
              ...styles.header,
              ...styles.centered,
              flexDirection: "row",
            }}
          >
            {/* <Svg height="70" width="70" viewBox="0 0 1687 1687">
              <Circle cx="843.5" cy="843.5" r="843.5" fill="#1e679c" />
              <Path
                d="M1359.21 882.366L1302.5 917.471C1295.14 922.028 1290.66 930.07 1290.66 938.728V1073.02C1290.66 1081.93 1285.92 1090.16 1278.22 1094.63L866.155 1334.21C858.426 1338.7 848.885 1338.72 841.133 1334.27L424.275 1094.7C416.438 1090.19 411.643 1081.81 411.733 1072.77L416.524 593.633C416.613 584.74 421.42 576.564 429.147 572.161L841.213 337.379C848.924 332.986 858.386 333.01 866.075 337.442L1273.36 572.23C1280.94 576.6 1285.69 584.618 1285.87 593.368L1289.82 782.822C1290.2 801.381 1309.97 813.06 1326.41 804.447L1383.96 774.299C1392.2 769.984 1397.36 761.453 1397.36 752.154V532.703C1397.36 523.785 1392.61 515.543 1384.9 511.072L866.138 210.482C858.417 206.008 848.896 205.989 841.157 210.432L317.432 511.089C309.667 515.547 304.879 523.817 304.879 532.77V1138.87C304.879 1147.89 309.734 1156.2 317.584 1160.64L841.31 1456.45C848.971 1460.77 858.343 1460.75 865.986 1456.4L1384.75 1160.65C1392.55 1156.21 1397.36 1147.92 1397.36 1138.94V903.623C1397.36 884.035 1375.86 872.056 1359.21 882.366Z M1201.8 1045.99L861.054 1240.7C856.471 1243.32 850.849 1243.34 846.25 1240.75L500.528 1045.97C495.81 1043.32 492.891 1038.32 492.891 1032.91V744.495C492.891 732.514 506.243 725.368 516.211 732.014L592.919 783.152C597.092 785.934 599.598 790.618 599.598 795.633V972.055C599.598 977.404 602.446 982.347 607.073 985.031L846.139 1123.69C850.793 1126.39 856.536 1126.39 861.191 1123.69L1100.26 985.031C1104.88 982.347 1107.73 977.404 1107.73 972.055V706.938C1107.73 695.378 1095.21 688.162 1085.21 693.962L861.204 823.883C856.543 826.587 850.789 826.582 846.132 823.871L535.487 643.048C525.548 637.263 525.548 622.906 535.487 617.121L846.559 436.049C850.985 433.472 856.421 433.332 860.974 435.678L996.789 505.643C1007.37 511.093 1007.69 526.098 997.362 532.002L922.16 574.974C917.507 577.633 911.789 577.608 907.16 574.907L861.114 548.047C856.502 545.357 850.807 545.321 846.161 547.954L724.958 616.636C714.668 622.466 714.859 637.356 725.294 642.921L846.356 707.487C850.905 709.913 856.381 709.834 860.857 707.276L1094.9 573.536C1099.68 570.808 1105.56 570.911 1110.24 573.806L1202.25 630.767C1206.67 633.502 1209.36 638.327 1209.36 643.521V1032.97C1209.36 1038.35 1206.47 1043.32 1201.8 1045.99Z"
                fill="#ffffff"
              />
              
            </Svg> */}
            <Image
              src={FbLogo}
              style={{
                width: 120,
                height: 70,
                marginBottom: 10,
                marginLeft: 5,
              }}
            />

            {/* <Svg height="70" widht="70" viewBox="0 0 290.32 173.93">
              <Path
                d="M11.68 131.75H3.53v5.62h7.87v3.32H3.53v11.14H0v-23.4h11.68ZM17.74 140a11.43 11.43 0 0 1 3.63-8.48A11.88 11.88 0 0 1 30 128a11.67 11.67 0 0 1 8.58 3.58 11.65 11.65 0 0 1 3.59 8.59 11.51 11.51 0 0 1-3.6 8.56 12.37 12.37 0 0 1-16.89.39 11.51 11.51 0 0 1-3.94-9.12Zm3.56 0a8.73 8.73 0 0 0 8.6 9 8.42 8.42 0 0 0 6.21-2.55 9.09 9.09 0 0 0 0-12.55 8.28 8.28 0 0 0-6.11-2.59 8.36 8.36 0 0 0-6.17 2.54 8.45 8.45 0 0 0-2.53 6.22ZM57.67 141.86l7.25 10H60.6l-6.69-9.58h-.63v9.58h-3.53v-23.4h4.13q4.65 0 6.7 1.74a6.39 6.39 0 0 1 2.28 5.12 6.66 6.66 0 0 1-1.43 4.28 6.39 6.39 0 0 1-3.76 2.26Zm-4.39-2.69h1.12c3.34 0 5-1.28 5-3.83s-1.63-3.59-4.88-3.59h-1.24ZM84.45 131.75h-9.38v5.62h9.11v3.32h-9.11v7.82h9.38v3.32H71.54v-23.4h12.91ZM93.37 128.43l6.47 16.21 6.56-16.21h3.87l-10.5 25.15-10.26-25.15ZM129.19 131.75h-9.38v5.62h9.11v3.32h-9.11v7.82h9.38v3.32h-12.91v-23.4h12.91ZM144.86 141.86l7.24 10h-4.32l-6.68-9.58h-.64v9.58h-3.53v-23.4h4.14q4.63 0 6.7 1.74a6.41 6.41 0 0 1 2.27 5.12 6.65 6.65 0 0 1-1.42 4.28 6.42 6.42 0 0 1-3.76 2.26Zm-4.4-2.69h1.13q5 0 5-3.83c0-2.4-1.62-3.59-4.88-3.59h-1.26ZM171.4 151.83v-23.4h3.52a15.5 15.5 0 0 1 3.74.36A5.52 5.52 0 0 1 181 130a6.31 6.31 0 0 1 1.56 2.23 6.65 6.65 0 0 1 .59 2.73 5.52 5.52 0 0 1-1.92 4.25 5.71 5.71 0 0 1 2.94 2.23 6.6 6.6 0 0 1-.85 8.31 6.53 6.53 0 0 1-2.62 1.62 15.39 15.39 0 0 1-4 .44Zm3.54-13.35H176a4 4 0 0 0 2.89-.88 3.37 3.37 0 0 0 .92-2.56 3.24 3.24 0 0 0-.94-2.51 3.94 3.94 0 0 0-2.73-.86h-1.24Zm0 10h2.18a5.38 5.38 0 0 0 3.51-.94 3.42 3.42 0 0 0 .05-5.12q-1.11-1-4-1h-1.78ZM206.26 146.14h-10l-2.61 5.69h-3.8L201.41 127l11.17 24.87h-3.87Zm-1.44-3.31-3.47-8-3.64 8ZM217.79 151.83l4.92-25.16 8 18.19 8.32-18.19 4.43 25.16h-3.62l-2.26-14.13-6.93 15.2-6.65-15.21-2.51 14.14ZM251.55 151.83v-23.4h3.51a15.59 15.59 0 0 1 3.75.36 5.63 5.63 0 0 1 2.38 1.23 6.42 6.42 0 0 1 1.55 2.23 6.67 6.67 0 0 1 .6 2.73 5.53 5.53 0 0 1-1.93 4.25 5.71 5.71 0 0 1 2.94 2.23 6.6 6.6 0 0 1-.85 8.31 6.53 6.53 0 0 1-2.62 1.62 15.36 15.36 0 0 1-4 .44Zm3.53-13.35h1.1a4 4 0 0 0 2.89-.88 3.37 3.37 0 0 0 .93-2.6 3.24 3.24 0 0 0-.94-2.51 3.94 3.94 0 0 0-2.73-.86h-1.24Zm0 10h2.18a5.36 5.36 0 0 0 3.51-.94 3.4 3.4 0 0 0 .05-5.12c-.74-.68-2.05-1-3.95-1h-1.79ZM276.53 128.43v14.09a7.73 7.73 0 0 0 1 4.41 5.26 5.26 0 0 0 8.29 0 7.61 7.61 0 0 0 1-4.41v-14.09h3.53v15.06a8.39 8.39 0 0 1-2.3 6.09 8.9 8.9 0 0 1-12.71 0 8.39 8.39 0 0 1-2.31-6.09v-15.06Zm0-6.29 3-2.11 4.85 4.88-1.68 1.41ZM29.57 173.69h-.95v-9.36h.95ZM37 172.82h4.36v.87h-5.29v-9.36h1ZM55.24 173.69h-1v-9.36h2.88a3.62 3.62 0 0 1 2.25.63 2.18 2.18 0 0 1 .83 1.87 2.4 2.4 0 0 1-.61 1.65 2.68 2.68 0 0 1-1.78.77l2.69 4.44h-1.11l-2.56-4.35h-1.59Zm0-5.22h1.69a3.76 3.76 0 0 0 1.08-.13 2.14 2.14 0 0 0 .71-.35 1.37 1.37 0 0 0 .38-.52 1.74 1.74 0 0 0 0-1.27 1.45 1.45 0 0 0-.38-.52 2 2 0 0 0-.71-.35 4.18 4.18 0 0 0-1.08-.12h-1.69ZM67 172.82h5v.87h-6v-9.36h5.8v.88H67v3.18h4.54v.87H67ZM82.32 165.88a2 2 0 0 0-1.81-.91 2.5 2.5 0 0 0-.72.1 2.14 2.14 0 0 0-.65.3 1.54 1.54 0 0 0-.62 1.29 1.37 1.37 0 0 0 .35 1 3 3 0 0 0 .89.57 9.8 9.8 0 0 0 1.16.4 5.15 5.15 0 0 1 1.15.48 2.8 2.8 0 0 1 .89.79 2.19 2.19 0 0 1 .35 1.33 2.26 2.26 0 0 1-.27 1.14 2.58 2.58 0 0 1-.71.86 3.63 3.63 0 0 1-1 .53 3.52 3.52 0 0 1-1.1.18 4.32 4.32 0 0 1-1.64-.32 3.12 3.12 0 0 1-1.31-1.07l.87-.62a2.31 2.31 0 0 0 .84.83 2.61 2.61 0 0 0 1.28.31A2.45 2.45 0 0 0 81 173a2.07 2.07 0 0 0 .64-.34 1.71 1.71 0 0 0 .47-.53 1.44 1.44 0 0 0 .18-.73 1.48 1.48 0 0 0-.2-.81 1.74 1.74 0 0 0-.54-.54 3.43 3.43 0 0 0-.77-.37l-.88-.29a6.76 6.76 0 0 1-.9-.39 3 3 0 0 1-.77-.47 2.16 2.16 0 0 1-.54-.71 2.48 2.48 0 0 1-.2-1.08 2.52 2.52 0 0 1 .25-1.17 2.47 2.47 0 0 1 .69-.84 3.06 3.06 0 0 1 1-.49 4.13 4.13 0 0 1 1.11-.15 3.89 3.89 0 0 1 1.44.25 3 3 0 0 1 1.21.88ZM89.21 164.33h2.72a3.65 3.65 0 0 1 2.26.63 2.17 2.17 0 0 1 .82 1.87 2.23 2.23 0 0 1-.82 1.89 3.72 3.72 0 0 1-2.26.62h-1.77v4.35h-1Zm1 4.14h1.49a3.68 3.68 0 0 0 1.07-.13 2.14 2.14 0 0 0 .71-.35 1.27 1.27 0 0 0 .38-.52 1.74 1.74 0 0 0 0-1.27 1.34 1.34 0 0 0-.38-.52 2 2 0 0 0-.71-.35 4.1 4.1 0 0 0-1.07-.12h-1.54ZM101.71 173.69h-.95v-9.36h.95ZM109.17 173.69h-1v-9.36h2.88a3.62 3.62 0 0 1 2.25.63 2.18 2.18 0 0 1 .83 1.87 2.36 2.36 0 0 1-.62 1.65 2.65 2.65 0 0 1-1.77.77l2.69 4.44h-1.16l-2.56-4.35h-1.59Zm0-5.22h1.69a3.8 3.8 0 0 0 1.08-.13 2.24 2.24 0 0 0 .71-.35 1.37 1.37 0 0 0 .38-.52 1.74 1.74 0 0 0 0-1.27 1.45 1.45 0 0 0-.38-.52 2 2 0 0 0-.71-.35 4.24 4.24 0 0 0-1.08-.12h-1.69ZM129.14 169a5 5 0 0 1-.37 2 4.9 4.9 0 0 1-1 1.56 4.9 4.9 0 0 1-3.49 1.39 4.92 4.92 0 0 1-1.93-.37 4.86 4.86 0 0 1-1.55-1 4.59 4.59 0 0 1-1-1.56 5.43 5.43 0 0 1 0-3.94 4.59 4.59 0 0 1 2.57-2.57 5.24 5.24 0 0 1 3.87 0 4.65 4.65 0 0 1 1.55 1 4.86 4.86 0 0 1 1 1.55 5.08 5.08 0 0 1 .35 1.94Zm-1 0a4.7 4.7 0 0 0-.26-1.54 4 4 0 0 0-.76-1.29 3.7 3.7 0 0 0-1.21-.88 3.84 3.84 0 0 0-1.62-.33 3.8 3.8 0 0 0-1.61.33 3.7 3.7 0 0 0-1.21.88 4 4 0 0 0-.76 1.29 4.69 4.69 0 0 0 0 3.08 4 4 0 0 0 .76 1.29 3.73 3.73 0 0 0 1.21.89 3.8 3.8 0 0 0 1.61.33 3.84 3.84 0 0 0 1.62-.33 3.73 3.73 0 0 0 1.21-.89 4 4 0 0 0 .76-1.29 4.65 4.65 0 0 0 .23-1.54ZM142.52 164.33h3.11a5.68 5.68 0 0 1 1.75.29 5 5 0 0 1 1.58.88 4.59 4.59 0 0 1 0 7 4.82 4.82 0 0 1-1.58.88 5.4 5.4 0 0 1-1.75.29h-3.11Zm.95 8.49h1.85a5 5 0 0 0 1.86-.32 4.09 4.09 0 0 0 1.31-.86 3.5 3.5 0 0 0 .77-1.22 4.07 4.07 0 0 0 0-2.81 3.41 3.41 0 0 0-.77-1.22 3.93 3.93 0 0 0-1.31-.86 4.83 4.83 0 0 0-1.86-.32h-1.85ZM157.36 172.82h5v.87h-6v-9.36h5.8v.88h-4.85v3.18h4.54v.87h-4.54ZM169.17 172.82h4.36v.87h-5.31v-9.36h.95ZM186.43 164.33h2.72a3.65 3.65 0 0 1 2.26.63 2.17 2.17 0 0 1 .82 1.87 2.23 2.23 0 0 1-.82 1.89 3.72 3.72 0 0 1-2.26.62h-1.77v4.35h-.95Zm.95 4.14h1.54a3.68 3.68 0 0 0 1.07-.13 2.14 2.14 0 0 0 .71-.35 1.27 1.27 0 0 0 .38-.52 1.74 1.74 0 0 0 0-1.27 1.34 1.34 0 0 0-.38-.52 2 2 0 0 0-.71-.35 4.1 4.1 0 0 0-1.07-.12h-1.54ZM198.93 173.69h-1v-9.36h1ZM205.28 173.69h-1.11l4.07-9.36h.92l4.07 9.36h-1.11l-1-2.46h-4.78Zm1.39-3.33h4.05l-2-4.92ZM225.24 172.26v-7.93h1v9.36H225l-5.58-8v8h-.95v-9.36h1.19ZM233.67 172.82h5v.87h-6v-9.36h5.8v.88h-4.85v3.18h4.54v.87h-4.54ZM247.52 173.69h-1v-8.48h-3.13v-.88h7.22v.88h-3.14ZM255 173.69h-1.11l4.07-9.36h.92l4.08 9.36h-1.11l-1-2.46h-4.78Zm1.39-3.33h4l-2-4.92Z"
                // fill={"#aea222"}
              />

              <Path
                d="M128.75 9.11a30.33 30.33 0 0 0-.09 5c.21 2.55-.6 2.53-2.31 3.7 0 0-31 19.62-12.23 51.5 1.81 3.07 1.73 4.5 1.19 5.43-2.53 4.38-5.12 7.43-9.7 9.39a4.49 4.49 0 0 1-3.45.12 2.7 2.7 0 0 1-1.31-1 82.35 82.35 0 0 1-6.21-11.4S75.58 27.69 118.28 5.52a14.63 14.63 0 0 1 4.28-1.45c2.85-.46 6.56-.07 6.19 5.04ZM176 82.64a1 1 0 0 1 .44 1.47A35.57 35.57 0 0 1 165 94.79a47.18 47.18 0 0 1-23.06 6.43c-23.08.62-32-10.15-32-10.15-2.93-2.8-3.56-3.83.2-6 2.81-1.62 5.85-2.85 8.75-4.32 1.92-1 3.41 0 5 .83 25.06 15.55 44.14 6 51.28 1.14a1 1 0 0 1 1-.09ZM137.1 14.67s31.49-6.16 46.78 25.24a2.29 2.29 0 0 0 2.3 1.38 1.72 1.72 0 0 0 1.48-1.68v-1.07s-3.56-34.89-45-38.42a28.12 28.12 0 0 0-5.27 0c-3.57.39-5.6 1.47-6 5a53.42 53.42 0 0 0 .3 5.7 4.54 4.54 0 0 0 5.4 3.83ZM180.24 84c3.15-.87 6.27-.34 9.38.22a24.08 24.08 0 0 1 9.75 3.93l.49.36c.12.1.25.21.18.38s-.25.13-.4.11l-2.18-.26a97.13 97.13 0 0 0-16.52-1.12h-1.19a9.84 9.84 0 0 1-3.83-1l-.41-.18s2.74-2.03 4.73-2.44ZM180.06 79.72c6.39-3.59 12.78-4.37 20-3.22-.08.33-.38.33-.59.4-4.28 1.46-8.55 3-12.93 4.07a63.22 63.22 0 0 1-6.7 1.25 8.77 8.77 0 0 1-2.5-.19 8 8 0 0 1 2.72-2.31ZM179.78 78a26.58 26.58 0 0 0 7.61-6 89.69 89.69 0 0 0 8.08-10.86c.11-.15.3-.3.13-.53h-.15l-1.57.91C188 65 183.22 69.63 180.34 75.85a6.71 6.71 0 0 0-.56 2.15ZM176 81.47a7.13 7.13 0 0 0 1.88-3.94 12.07 12.07 0 0 0 .15-2.16 86.28 86.28 0 0 0-2.36-17.3c-.05-.22 0-.52-.39-.61a6.86 6.86 0 0 0-.51 1.65A63.7 63.7 0 0 0 173.39 73a19.49 19.49 0 0 0 .86 6.14 7.72 7.72 0 0 0 1.09 2.14l.32.46a3.11 3.11 0 0 0 .34-.27Z"
                fill={"#aea222"}
              />
              <Path
                d="M170.8 84.71a5.74 5.74 0 0 0 .68-3.68 23.33 23.33 0 0 0-.53-2.54 32.56 32.56 0 0 0-9.67-15.63 27.14 27.14 0 0 0-2.65-2.25c-.14-.1-.3-.24-.48-.09s-.05.28 0 .42.1.29.16.43c1.87 4.63 3.75 9.26 5.85 13.8a26.43 26.43 0 0 0 6.63 9.55Z"
                fill={"#aea222"}
              />
            </Svg> */}

            {/* <Text
                            style={{
                                ...styles.pablockName,
                                ...styles.centered,
                            }}
                        >
                            {i18n.t("pdfGenerator.pablock")}
                        </Text> */}
          </View>
          <View style={styles.content}>
            {/* <View
                            style={{
                                ...styles.row,
                                ...styles.centered,
                                flexDirection: "row",
                            }}
                        >
                            <View style={styles.leftCell}>
                                <Text>{i18n.t(`pdfGenerator.fileHash`)}</Text>
                            </View>
                            <View style={styles.rightCell}>
                                <Text>{notarization.fileHash}</Text>
                            </View>
                        </View> */}
            <View style={styles.titleContainer}>
              <Text style={styles.title}>
                {i18n.t("pdfGenerator.notarization_data")}
              </Text>
            </View>
            {generateTable(documentTable)}
            <View style={styles.titleContainer}>
              <Text style={styles.title}>
                {i18n.t("pdfGenerator.matic_transaction")}
              </Text>
            </View>
            {/* {generateTable(transactionFields, "maticTx")} */}
            {generateTable(transactionFields)}
            {/* <View style={styles.titleContainer}>
              <Text style={styles.title}>
                {i18n.t("pdfGenerator.ethereum_transaction")}
              </Text>
            </View>
            {notarization.ethTx ? (
              generateTable(transactionFields, "ethTx")
            ) : (
              <Text style={styles.rightText}>
                {i18n.t("pdfGenerator.no_eth_tx")}
              </Text>
            )} */}
          </View>
        </View>
      </Page>
    </Document>
  );
}

const styles = StyleSheet.create({
  centered: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  pablockName: {
    height: "100%",
    fontSize: 22,
    fontWeight: "bold",
    fontColor: colors.primary,
    borderWidth: 3,
    borderColor: "red",
  },
  page: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  innerPage: {
    width: "90%",
    height: "90%",
    // borderColor: "red",
    // borderWidth: 1,
    // padding: "30px",
  },
  header: {
    borderColor: colors.primary,
    borderBottomWidth: 2,
    textAlign: "center",
    fontSize: "28px",
    width: "100%",
    height: 80,
    paddingBottom: 10,
  },
  content: { height: "100%" },
  titleContainer: { margin: 20 },
  title: { fontSize: 20, fontWeight: "bold" },
  row: {
    position: "relative",
    height: 30,
    width: "100%",
    // borderWidth: 1,
    // borderColor: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "row",
  },
  leftCell: {
    height: "100%",
    width: "30%",
    borderWidth: 1,
    borderColor: "black",
  },
  rightCell: {
    height: "100%",
    width: "70%",
    borderWidth: 1,
    borderColor: "black",
  },
  leftText: { fontWeight: "bold", fontSize: 12, color: colors.primary },
  rightText: { fontSize: 10 },
});
